import { SxProps } from '@mui/material';
import theme from '@theme/index';

const { palette } = theme;

const commonDrawerHeading = {
  fontWeight: 700,
  fontSize: { md: '1.5rem', xs: '1rem' },
  textAlign: { md: 'left', xs: 'center' },
  width: '100%'
};

const styles: Record<string, SxProps> = {
  mainContainer: {
    paddingY: { md: '2.5rem', xs: '1.25rem' },
    paddingX: { md: '2rem', xs: '1rem' },
    width: { md: '37vw', xs: '100vw' }
  },
  headerDivider: {
    width: '100vw',
    marginLeft: '-1rem',
    borderColor: palette.primary[200],
    display: { xs: 'block', md: 'none' }
  },
  headerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: { xs: '1.25rem', md: '0' }
  },
  drawerHeading: commonDrawerHeading,
  closeIcon: {
    cursor: 'pointer',
    width: { md: '1.25rem', sm: '0.75rem' }
  },

  filterHeading: {
    ...commonDrawerHeading,
    mt: '2rem',
    mb: '1rem',
    fontSize: '1.5rem',
    lineHeight: '1.5rem',
    textAlign: 'left'
  },
  infoText: {
    fontSize: '0.875rem',
    color: palette.grey[400],
    mt: '1.5rem'
  },
  text: {
    fontSize: '0.875rem',
    color: palette.grey.main,
    mt: '1rem'
  },
  filterButton: {
    padding: { xs: '0rem', md: '0rem' },
    fontSize: '0.875rem',
    fontWeight: '700',
    height: 'auto',
    minWidth: 'auto',
    textTransform: 'initial',
    my: '0.5rem'
  },
  filtersBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
};

export default styles;
